var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 4,
    viewBox: "0 0 17 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 1.87821C16.9783 2.25707 16.8346 2.6233 16.5658 2.8885C16.3034 3.16002 15.9409 3.31156 15.566 3.31156H9.91665H7.08575H1.43644C1.06148 3.31156 0.699026 3.16002 0.436558 2.8885C0.174091 2.6233 0.0241089 2.25707 0.0241089 1.87821C0.0241089 1.49935 0.174091 1.13943 0.436558 0.867918C0.699026 0.602716 1.06148 0.451172 1.43644 0.451172H7.08575H9.91665H15.566C15.9409 0.451172 16.3034 0.602716 16.5658 0.867918C16.8346 1.13943 16.9783 1.49935 16.9783 1.87821Z",
    fill: "#FFAA23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenos);
export default __webpack_public_path__ + "static/media/menos.8b3c61d67a126df6e216a57c430c42d5.svg";
export { ForwardRef as ReactComponent };